import React from "react";
import { Box, Button, Typography, Paper } from "@mui/material";
import { useEffect } from "react";
import StoreIcon from "@mui/icons-material/Store";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import Background from "./components/Background"

const ChooseLogin = ({ setTipo, tipo }) => {
  
  useEffect(() => {
    localStorage.removeItem('selectedTab')
    sessionStorage.removeItem('selectedTab')
  },[])

  const handleClickPartner = () => {
    setTipo("reseller");
    window.sessionStorage.setItem("type", "reseller");
    window.location.href = "/reseller/login";
    //navigate("/reseller/login");
  };
  const handleClickUser = () => {
    setTipo("user");
    window.sessionStorage.setItem("type", "user");
    window.location.href = "/user/login";
    //navigate("/user/login");
  };

  return (
    <>
      <Background/>
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        height="80vh"
      >
        <Typography>
          <img
            src="/logoWhite.png"
            alt="LECS"
            style={{ width: "auto", height: "80px", marginBottom: "30px" }}
          />
        </Typography>
        <Typography variant="h2" gutterBottom className="typoChooseLogin" fontWeight={700}>
          WELCOME TO YOUR LECS DASHBOARD
        </Typography>

        <Box display="flex" justifyContent="space-around"  mt={10} sx={{width: {xs:"75%",md:"30%"}}}>
          {/* Partner Card */}
          <Paper
             style={{
              width: "161px",
              height: "200px",
              padding: "2rem",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              border:"solid 2px #49BECE",
              borderRadius: "10px"
            }}
            sx={{
              backgroundColor: "#000",
              backgroundImage: "none",
              transition:
                "box-shadow 0.3s ease-in-out, transform 0.3s ease-in-out",
              ":hover": {
                boxShadow: "0px 50px 55px rgba(0,0,0,0.2)",
                transform: "translateY(-15px)",
                /*backgroundColor: "#1e1e1e",*/
              },
            }}
          >
            <Typography>
              <StoreIcon fontSize="large" />
            </Typography>
            <Typography sx={{ marginBottom: "40px", fontWeight: 900 }} variant="h6" gutterBottom>
              PARTNER
            </Typography>
            <Button
              sx={{
                backgroundColor: "#2d2d2d",
                fontWeight: 900,
                '&:hover': {
                  backgroundColor: "#eaeaea !important",
                  boxShadow: "0px 0px 25px #0097B2",
                  color: "#0097B2"
                },
              }}
              color="primary"
              variant="contained"
              className="btn-chooseLogin"
              value={"Partner"}
              onClick={handleClickPartner}
            >
              Sign In
            </Button>
          </Paper>

          {/* Spacer */}
          <Box width="2rem"className="spacerChooseLogin"></Box>

          {/* User Card */}
          <Paper
            style={{
              width: "161px",
              height: "200px",
              padding: "2rem",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              border:"solid 2px #49BECE",
              borderRadius: "10px"
            }}
            sx={{
              backgroundColor: "#000",
              backgroundImage: "none",
              transition:
                "box-shadow 0.3s ease-in-out, transform 0.3s ease-in-out",
              ":hover": {
                boxShadow: "0px 50px 55px rgba(0,0,0,0.2)",
                transform: "translateY(-15px)",
                /*backgroundColor: "#1e1e1e",*/
              },
            }}
          >
            <Typography>
              <AccountCircleIcon fontSize="large" />
            </Typography>
            <Typography sx={{ marginBottom: "40px", fontWeight: 900 }} variant="h6" gutterBottom>
              USER
            </Typography>
            <Button
            sx={{
              backgroundColor: "#2d2d2d",
              fontWeight: 900,
              '&:hover': {
                backgroundColor: "#eaeaea !important",
                boxShadow: "0px 0px 25px #0097B2",
                color: "#0097B2"
              },
            }}
              variant="contained"
              color="primary"
              value={"User"}
              onClick={handleClickUser}
            >
              Sign In
            </Button>
          </Paper>
        </Box>
      </Box>
    </>
  );
};

export default ChooseLogin;
